<template>
    <v-tooltip top :color="bg" content-class="bp-tooltip" :disabled="!truncated">
        <template v-slot:activator="{ on, attrs }">
            <span ref="text" class="truncated-text" v-bind="attrs" v-on="on">{{ text }}</span>
        </template>
        <span>{{ text }}</span>
    </v-tooltip>
</template>

<script>
export default {
    name: "TruncatedText",
    props: {
        text: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            truncated: false,
        }
    },
    computed: {
        bg(vm = this) {
            return vm.$vuetify.theme.dark ? '#0C0E12' : '#FFFFFF'
        },
    },
    mounted() {
        this.$nextTick(this.check)
        window.addEventListener('resize', this.check)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.check)
    },
    watch: {
        text() {
            this.$nextTick(this.check)
        },
    },
    methods: {
        check() {
            const el = this.$refs.text
            this.truncated = !!el && el.scrollWidth > el.clientWidth
        },
    },
}
</script>

<style scoped>
.truncated-text {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
}
</style>
